import { db } from '../db/dexie.js';
import { pagosHechos, type EventoDePago, type PagoHecho } from './historialDinero.js';
import { leerSinEfecto, tuvoEfecto } from './sinEfecto.js';

/**
 * Every payment made to a supplier, the latest first, as `pagosHechos` lists them: what «Gastos»
 * shows the latest of, and «Pagos a proveedores» all of.
 */
export async function leerPagosHechos(): Promise<PagoHecho[]> {
  const [eventos, compras, gastos, sinEfecto] = await Promise.all([
    db.eventos.where('type').anyOf(['compra.pagada', 'gasto.pagado']).toArray(),
    db.compras.toArray(),
    db.gastos.toArray(),
    leerSinEfecto(),
  ]);
  return pagosHechos(
    eventos
      // A payment the books refused — a bill already paid from another phone — paid nothing.
      .filter((e) => tuvoEfecto(e, sinEfecto))
      .map((e) => ({ id: e.id, clientTs: e.clientTs, payload: e.payload as EventoDePago['payload'] })),
    new Map(compras.map((c) => [c.id, c])),
    new Map(gastos.map((g) => [g.id, g])),
  );
}
